<template>
  <div class="inputer-list-page">
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row class="main-content">
      <el-col :span="4" class="menu-col">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20" class="content-col">
        <!-- 页面标题 -->
        <div class="page-header">
          <div class="header-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4" fill="url(#gradient1)"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              <defs>
                <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style="stop-color:#FF6B6B;stop-opacity:1" />
                  <stop offset="50%" style="stop-color:#FFD166;stop-opacity:1" />
                  <stop offset="100%" style="stop-color:#06D6A0;stop-opacity:1" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div class="header-text">
            <h2>填表人管理</h2>
            <p>管理填表人分组，方便批量发放表格</p>
          </div>
        </div>

        <!-- 操作按钮区 -->
        <div class="action-bar">
          <el-tooltip effect="dark" content="没有需要的组，点我添加" placement="bottom">
            <el-button class="btn-primary-custom" @click="addGroup()">
              <i class="el-icon-plus"></i> 添加新组
            </el-button>
          </el-tooltip>
        </div>

        <!-- 表格区域 -->
        <div class="table-section">
          <el-table border :data="inputerList" stripe class="custom-table"
            :header-cell-style="{background:'linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)',color:'#1a1a1a',fontWeight:'600'}">
            <el-table-column type="index" label="序号" width="60" header-align="center" align="center">
              <template slot-scope="scope">
                <span class="index-badge">{{scope.$index + 1}}</span>
              </template>
            </el-table-column>

            <el-table-column prop="group_name" label="分组名称" min-width="250">
              <template slot-scope="scope">
                <div class="group-name">
                  <i class="el-icon-user-solid"></i>
                  <span>{{scope.row.group_name}}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="total" label="人数" align="center" width="120">
              <template slot-scope="scope">
                <span class="count-badge">{{scope.row.total}} 人</span>
              </template>
            </el-table-column>

            <el-table-column label="操作" header-align="center" align="center" width="180">
              <template slot-scope="scope">
                <div class="action-btns">
                  <el-button class="btn-view" @click.native.prevent="viewInputerList(scope.$index)" type="text" size="small">
                    <i class="el-icon-view"></i> 查看
                  </el-button>
                  <el-button class="btn-delete" @click.native.prevent="delInpterList(scope.$index)" type="text" size="small">
                    <i class="el-icon-delete"></i> 删除
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <!-- 空状态 -->
          <div v-if="inputerList.length === 0" class="empty-state">
            <i class="el-icon-user"></i>
            <p>暂无填表人分组</p>
            <span>点击"添加新组"创建您的第一个分组</span>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 删除确认弹窗 -->
    <el-dialog :visible.sync="dialogVisible" custom-class="custom-dialog" width="400px">
      <div slot="title" class="dialog-title warning">
        <i class="el-icon-warning"></i>
        <span>重要提示</span>
      </div>
      <div class="dialog-body">
        <p class="dialog-msg">{{msg}}</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-danger-custom" @click="delGroupRecord">
          <i class="el-icon-delete"></i> 删 除
        </el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 分组内容弹窗 -->
    <el-dialog :close-on-click-modal="false" v-dialogDrag :visible.sync="downloadExcelDialogVisible" custom-class="custom-dialog" width="500px">
      <div slot="title" class="dialog-title">
        <i class="el-icon-document"></i>
        <span>分组内容</span>
      </div>
      <div class="dialog-body center">
        <div class="download-icon">📊</div>
        <p class="download-text">Excel文件已经生成</p>
        <p class="download-tip">请点下载按钮获取文件</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-primary-custom" @click="downloadExcel">
          <i class="el-icon-download"></i> 下 载
        </el-button>
        <el-button @click="downloadExcelDialogVisible=false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- Zip文件下载弹窗 -->
    <el-dialog :close-on-click-modal="false" v-dialogDrag :visible.sync="downloadZipDialogVisible" custom-class="custom-dialog" width="500px">
      <div slot="title" class="dialog-title">
        <i class="el-icon-document-copy"></i>
        <span>下载压缩包文件</span>
      </div>
      <div class="dialog-body center">
        <div class="download-icon">📦</div>
        <p class="download-text">压缩包文件已经生成</p>
        <p class="download-tip">下载后用解压工具打开</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-primary-custom" @click="downloadZip">
          <i class="el-icon-download"></i> 下 载
        </el-button>
        <el-button @click="downloadZipDialogVisible=false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- PDF文件下载弹窗 -->
    <el-dialog :close-on-click-modal="false" v-dialogDrag :visible.sync="downloadPDFDialogVisible" custom-class="custom-dialog" width="500px">
      <div slot="title" class="dialog-title">
        <i class="el-icon-document-checked"></i>
        <span>下载PDF文件</span>
      </div>
      <div class="dialog-body center">
        <div class="download-icon">📄</div>
        <p class="download-text">PDF文件已经生成</p>
        <p class="download-tip">请点下载按钮获取文件</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-primary-custom" @click="downloadPDF">
          <i class="el-icon-download"></i> 下 载
        </el-button>
        <el-button @click="downloadPDFDialogVisible=false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 添加新组弹窗 -->
    <el-dialog :close-on-click-modal="false" v-dialogDrag :visible.sync="addGroupDialogVisible" custom-class="custom-dialog" width="550px">
      <div slot="title" class="dialog-title">
        <i class="el-icon-circle-plus-outline"></i>
        <span>添加新组</span>
      </div>
      <div class="dialog-body">
        <el-form label-position="top" class="group-form">
          <el-form-item label="分组名称">
            <el-input 
              v-model="group_name" 
              placeholder="请输入分组名称，如：一年级一班" 
              prefix-icon="el-icon-collection-tag"
              size="medium">
            </el-input>
          </el-form-item>
          
          <el-form-item label="组内名单">
            <el-input 
              type="textarea" 
              :rows="8" 
              placeholder="请输入成员名单，一行一个姓名" 
              v-model="group_detail"
              class="member-input">
            </el-input>
            <div class="input-hint">
              <i class="el-icon-info"></i>
              <span>每行输入一个姓名，系统将自动统计人数</span>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-primary-custom" @click="addGroupList">
          <i class="el-icon-check"></i> 添 加
        </el-button>
        <el-button @click="addGroupDialogVisible=false">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'
  import '../assets/global.css'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        inputerList: [],
        addGroupDialogVisible: false,
        group_detail: '',
        group_name: '',
        group_id: '',
        username: '',
        tableData: [],
        dialogVisible: false,
        searchResultSettingDialogTableVisible: false,
        position: -1,
        msg: '',
        configurations: [],
        showPosition: false,
        unReadDialogFormVisible: false,
        shownotify: 0,
        successDialogVisible: false,
        downloadExcelDialogVisible: false,
        downloadZipDialogVisible: false,
        sendFormDialogVisible: false,
        current_download_file_name: '',
        selected_form_id: '',
        selected_form_name: '',
        downloadPDFDialogVisible: false
      }
    },
    mounted() {
      this.username = this.$session.get('USERNAME')
    },
    created() {
      console.log('调用exam_list created')
      this.username = this.$session.get('USERNAME')
      this.loadData()
    },
    methods: {
      loadData() {
        console.log('加载数据')
        let that = this
        const load = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        var requestUrl = '/form/web/_load_inputer_list.jsp'
        this.axios.get(requestUrl, {
            params: {
              publish_name: that.username
            }
          }).then(function(response) {
            that.inputerList = response.data.group_list
            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      indexMethod() {
        this.index++
        return this.index
      },
      convertPaperScore(course, paperScore) {
        if (course === '总分' || course.indexOf('排名') >= 0) {
          return '/'
        } else {
          return paperScore
        }
      },
      convertState: function(row, column) {
        var state = row.state
        if (typeof (state) === 'undefined' || state === 1) {
          return '未发放'
        }
        if (state === 2) {
          return '正在填写'
        }
        if (state === 100) {
          return '已收回'
        }
      },
      convertPages: function(row, column) {
        var inputPages = row.input_pages
        if (typeof (inputPages) === 'undefined' || inputPages === 1) {
          return '1张/人'
        }
        if (inputPages > 1) {
          return '多张/人'
        }
      },
      viewExam(index, rows) {
        var examID = rows[index].id
        var exam = rows[index].exam
        console.log('查看成绩单:' + exam)
        this.$router.push({
          name: 'exam_detail',
          params: {
            id: examID,
            exam: exam
          }
        })
      },
      deleteForm(index, rows) {
        this.position = index
        this.selected_form_id = rows[index].id
        var state = rows[index].state
        if (state === 2) {
          this.$alert('《' + rows[index].form_name + '》正在填写，如要删除，请先收回表格！', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.function()
            }
          })
          return
        }
        if (rows[index].submit_count > 0) {
          this.msg = '"' + rows[index].form_name + '"中有数据，导出可备份数据。如已备份且确实需要删除，请点"删除"，否则请点击"取消"!'
        } else {
          this.msg = '确定要删除《' + rows[index].form_name + '》吗?'
        }
        this.dialogVisible = true
      },
      delFormContentRecord() {
        let that = this
        this.dialogVisible = false
        var requestUrl = '/form/web/_delete_form_data_and_template.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.selected_form_id
            }
          }).then(function(response) {
            that.tableData.splice(that.position, 1)
            that.$message.success('删除成功！')
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      tackbackForm(index, rows) {
        let that = this
        this.position = index
        this.selected_form_id = rows[index].id
        this.msg = '收回表格会停止填写表格，尚未填写的将不能继续填写，如要填写需要重新发放，要收回表格吗?'
        that.$confirm(this.msg, '操作提示', {
          confirmButtonText: '全部收回',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var requestUrl = '/form/web/_tack_back_form.jsp'
          that.axios.get(requestUrl, {
              params: {
                form_id: that.selected_form_id
              }
            }).then(function(response) {
              that.loadData()
              that.$message.success('收回成功！')
            })
            .catch(function(error) {
              console.log(error)
            })
        }).catch(() => {})
      },
      editExam(index, rows) {
        this.position = index
        this.selectedExamID = rows[index].id
        let that = this
        this.$router.push({
          name: 'exam_edit',
          params: {
            id: that.selectedExamID
          }
        })
      },
      importExcel() {
        this.$router.push('/import_data_excel')
      },
      importMutiExcel() {
        this.$router.push('/exam_import_anyfile')
      },
      createNewExam() {
        this.$router.push('/exam_new')
      },
      indexMethods(index) {
        return this.tableData.length - index
      },
      viewUnSearchList(index, rows) {
        let that = this
        this.position = index
        this.selectedExamID = rows[index].id
        const load = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        var requestUrl = '/score/web/_get_students_score_list_unsearch.jsp'
        this.axios.get(requestUrl, {
            params: {
              id: that.selectedExamID
            }
          }).then(function(response) {
            that.students = response.data
            that.unReadDialogFormVisible = true
            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      closeUnreadDialog() {
        this.unReadDialogFormVisible = false
      },
      filterExams(date) {
        console.log(date)
      },
      selectChanged() {
        console.log(this.filterCondition)
        this.loadData()
      },
      phoneShowSetting() {
        this.searchResultSettingDialogTableVisible = true
      },
      importedNextStep() {
        this.successDialogVisible = true
      },
      exportToFile(index, rows) {
        var formId = rows[index].id
        let that = this
        const load = this.$loading({
          lock: true,
          text: '生成文件中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        var requestUrl = ''
        var fileType = rows[index].file_type
        if (fileType === 'EXCEL') {
          requestUrl = '/form/web/_export_to_excel.jsp'
        } else if (fileType === 'ZIP') {
          requestUrl = '/form/web/_export_to_zip.jsp'
        }
        this.axios.get(requestUrl, {
          params: {
            username: that.username,
            form_id: formId
          }
        }).then(function(response) {
          console.log(response)
          var fileName = ''
          if (fileType === 'EXCEL') {
            fileName = '/form/temp/' + formId + '.xls'
            that.downloadExcelDialogVisible = true
            that.current_download_file_name = fileName
          } else if (fileType === 'ZIP') {
            fileName = '/form/temp/' + formId + '.zip'
            that.downloadZipDialogVisible = true
            that.current_download_file_name = fileName
          }
          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      exportToPDF(index, rows) {
        var formId = rows[index].id
        let that = this
        const load = this.$loading({
          lock: true,
          text: '生成PDF中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        var requestUrl = '/form/web/_export_to_pdf.jsp'
        this.axios.get(requestUrl, {
          params: {
            username: that.username,
            form_id: formId
          }
        }).then(function(response) {
          console.log(response)
          that.downloadPDFDialogVisible = true
          that.current_download_file_name = response.data.pdf_filename
          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      createNewForm() {},
      downloadExcel() {
        this.downloadExcelDialogVisible = false
        window.open(this.current_download_file_name)
      },
      downloadZip() {
        this.downloadZipDialogVisible = false
        window.open(this.current_download_file_name)
      },
      downloadPDF() {
        this.downloadPDFDialogVisible = false
        window.open(this.current_download_file_name)
      },
      sendForm(index, rows) {
        this.selected_form_name = rows[index].form_name
        this.sendFormDialogVisible = true
      },
      browseData(index, rows) {
        var formId = rows[index].id
        var url = '/form/web/_browse_form_data.jsp?form_id=' + formId
        window.open(url)
      },
      openMakeForm() {
        this.$router.push('/make_form')
      },
      addGroup() {
        this.group_name = ''
        this.group_detail = ''
        this.addGroupDialogVisible = true
      },
      addGroupList() {
        if (!this.group_name.trim()) {
          this.$message.error('请输入分组名称！')
          return
        }
        let that = this
        const load = this.$loading({
          lock: true,
          text: '保存中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        var requestUrl = '/form/web/_save_group_list.jsp'
        this.axios.get(requestUrl, {
            params: {
              publish_name: that.username,
              group_name: that.group_name,
              group_content: that.group_detail
            }
          }).then(function(response) {
            that.addGroupDialogVisible = false
            that.group_name = ''
            that.group_detail = ''
            that.loadData()
            load.close()
            that.$message.success('添加成功！')
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      delInpterList(index) {
        this.position = index
        console.log(this.inputerList)
        this.group_id = this.inputerList[index].id
        this.msg = '要删除"' + this.inputerList[index].group_name + '"吗?'
        this.dialogVisible = true
      },
      delGroupRecord() {
        let that = this
        const load = this.$loading({
          lock: true,
          text: '删除中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        var requestUrl = '/form/web/_delete_group.jsp'
        this.axios.get(requestUrl, {
            params: {
              group_id: that.group_id
            }
          }).then(function(response) {
            that.dialogVisible = false
            that.loadData()
            load.close()
            that.$message.success('删除成功！')
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      viewInputerList(index) {
        let that = this
        this.group_id = this.inputerList[index].id
        this.$router.push({
          name: 'inputer_list_detail',
          params: {
            group_id: that.group_id
          }
        })
      }
    },
    watch: {
      $route() {
        this.loadData()
      }
    }
  }
</script>

<style scoped>
  /* 页面整体布局 */
  .inputer-list-page {
    min-height: 100vh;
    background: #f5f7fa;
  }

  .main-content {
    padding: 20px;
  }

  .menu-col {
    padding-right: 20px;
  }

  .content-col {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.06);
    padding: 30px;
    min-height: calc(100vh - 140px);
  }

  /* 页面标题 */
  .page-header {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
    padding-bottom: 20px;
    border-bottom: 2px solid #f0f0f0;
  }

  .header-icon {
    display: flex;
    align-items: center;
    margin-right: 18px;
  }
  
  .header-icon svg {
    width: 42px;
    height: 42px;
  }

  .header-text h2 {
    font-size: 24px;
    color: #1a1a1a;
    margin: 0 0 6px;
    font-weight: 600;
  }

  .header-text p {
    font-size: 14px;
    color: #888;
    margin: 0;
  }

  /* 操作按钮区 */
  .action-bar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 25px;
  }

  .btn-primary-custom {
    padding: 12px 28px;
    font-size: 14px;
    border-radius: 8px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    border: none;
    color: #fff;
    font-weight: 500;
    transition: all 0.3s ease;
  }

  .btn-primary-custom:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(20, 133, 251, 0.35);
    background: linear-gradient(135deg, #2d91fb 0%, #1a7cff 100%);
  }

  /* 表格区域 */
  .table-section {
    margin-top: 10px;
  }

  .custom-table {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  }

  /* 序号徽章 */
  .index-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    color: #fff;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 600;
  }

  /* 分组名称 */
  .group-name {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 500;
    color: #1a1a1a;
  }

  .group-name i {
    color: #1485FB;
    font-size: 18px;
  }

  /* 人数徽章 */
  .count-badge {
    display: inline-block;
    padding: 6px 16px;
    background: linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%);
    color: #1485FB;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
  }

  /* 操作按钮 */
  .action-btns {
    display: flex;
    justify-content: center;
    gap: 15px;
  }

  .btn-view {
    color: #1485FB;
    font-weight: 500;
  }

  .btn-view:hover {
    color: #0d6efd;
  }

  .btn-delete {
    color: #ff4d4f;
    font-weight: 500;
  }

  .btn-delete:hover {
    color: #ff7875;
  }

  /* 空状态 */
  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px 20px;
    color: #999;
  }

  .empty-state i {
    font-size: 64px;
    color: #ddd;
    margin-bottom: 20px;
  }

  .empty-state p {
    font-size: 16px;
    color: #666;
    margin: 0 0 10px;
  }

  .empty-state span {
    font-size: 13px;
    color: #999;
  }

  /* ==================== 弹窗样式 ==================== */
  ::v-deep .custom-dialog .el-dialog__header {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    padding: 0;
  }

  ::v-deep .custom-dialog .el-dialog__header.warning {
    background: linear-gradient(135deg, #ff6b6b 0%, #ff4d4f 100%);
  }

  .dialog-title {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 20px;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
  }

  .dialog-title i {
    font-size: 20px;
  }

  ::v-deep .custom-dialog .el-dialog__headerbtn {
    top: 20px;
    right: 20px;
  }

  ::v-deep .custom-dialog .el-dialog__headerbtn .el-dialog__close {
    color: rgba(255,255,255,0.8);
  }

  ::v-deep .custom-dialog .el-dialog__headerbtn:hover .el-dialog__close {
    color: #fff;
  }

  ::v-deep .custom-dialog .el-dialog__body {
    padding: 30px;
  }

  ::v-deep .custom-dialog .el-dialog__footer {
    border-top: 1px solid #f0f0f0;
    padding: 20px 30px;
  }

  .dialog-body {
    max-height: 500px;
    overflow-y: auto;
  }

  .dialog-body.center {
    text-align: center;
  }

  .dialog-msg {
    font-size: 15px;
    color: #555;
    line-height: 1.6;
    margin: 0;
  }

  /* 下载弹窗 */
  .download-icon {
    font-size: 64px;
    margin-bottom: 20px;
  }

  .download-text {
    font-size: 18px;
    color: #1a1a1a;
    font-weight: 600;
    margin: 0 0 10px;
  }

  .download-tip {
    font-size: 14px;
    color: #888;
    margin: 0;
  }

  /* 分组表单 */
  .group-form .el-form-item {
    margin-bottom: 25px;
  }

  .group-form .el-form-item__label {
    font-size: 15px;
    font-weight: 600;
    color: #1a1a1a;
    padding-bottom: 10px;
  }

  .member-input textarea {
    font-family: monospace;
    font-size: 14px;
    line-height: 1.6;
  }

  .input-hint {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 10px;
    font-size: 13px;
    color: #888;
  }

  .input-hint i {
    color: #1485FB;
  }

  /* 按钮样式 */
  .btn-danger-custom {
    padding: 10px 24px;
    font-size: 14px;
    border-radius: 8px;
    background: linear-gradient(135deg, #ff6b6b 0%, #ff4d4f 100%);
    border: none;
    color: #fff;
    font-weight: 500;
    transition: all 0.3s ease;
  }

  .btn-danger-custom:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 77, 79, 0.35);
    background: linear-gradient(135deg, #ff7875 0%, #ff5b5c 100%);
  }

  /* 响应式 */
  @media (max-width: 1200px) {
    .main-content {
      padding: 15px;
    }

    .content-col {
      padding: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/inputer_list.vue